import React from "react";
import Player from "./Player";
import "./styles.css";

export default function PlayerIndex(props) {
  return <Player {...props} />;
}
